import { render, staticRenderFns } from "./SaveCancelButtons.vue?vue&type=template&id=e813bfa0&scoped=true&"
import script from "./SaveCancelButtons.vue?vue&type=script&lang=js&"
export * from "./SaveCancelButtons.vue?vue&type=script&lang=js&"
import style0 from "./SaveCancelButtons.vue?vue&type=style&index=0&id=e813bfa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e813bfa0",
  null
  
)

export default component.exports